module.exports = __webpack_public_path__ + "img/pressalit_3.db472178.jpg";